import {
  getProductCategories,
  createProductCategory,
  updateProductCategory,
  deleteProductCategory,
  createMaterials,
  getMaterials,
  updateMaterials,
  deleteMaterials,
  createMaterialsTableId,
  getMaterialsTableId,
  getMaterialRemains,
  getMaterialRemainsExcel,
  updateMaterialsVid,
  deleteMaterialsVidId,
  getModalDetails,
  getMaterialForBuilders,
  exportExcelMaterialTypes,
  exportExcelMaterial,
} from "@/api/reference";

import {
  createWriteOffForGood,
  updateWriteOffForGood,
  updateWriteOffForInstrument,
} from "@/api/application";

export default {
  FETCH_MATERIAL_FOR_BUILDERS({ commit }, params) {
    return getMaterialForBuilders(params).then((res) => {
      commit("SET_MATERIALS_FOR_BUILDERS", res.data);
    });
  },
  FETCH_PRODUCT_CATEGORIES({ commit }, params) {
    return getProductCategories(params).then((res) => {
      commit("SET_PRODUCT_CATEGORIES", res.data);
    });
  },
  FETCH_MODAL_DETAILS({ commit }, params) {
    return getModalDetails(params).then((res) => {
      commit("SET_MODAL_DETAILS", res.data);
    });
  },
  CREATE_PRODUCT_CATEGORY(_, data) {
    return createProductCategory(data);
  },
  UPDATE_PRODUCT_CATEGORY(_, data) {
    return updateProductCategory(data);
  },
  DELETE_PRODUCT_CATEGORY(_, data) {
    return deleteProductCategory(data);
  },
  CREATE_MATERIALS(_, data) {
    return createMaterials(data);
  },
  FETCH_MATERIALS({ commit }, params) {
    return getMaterials(params).then((res) => {
      commit("SET_MATERIALS", res.data);
    });
  },
  UPDATE_MATERIALS(_, data) {
    return updateMaterials(data);
  },

  DELETE_MATERIALS(_, id) {
    return deleteMaterials(id);
  },

  // materialTableId
  CREATE_MATERIALS_TABLE_ID(_, data) {
    return createMaterialsTableId(data);
  },
  FETCH_MATERIALS_TABLE_ID({ commit }, params) {
    return getMaterialsTableId(params).then((res) => {
      commit("SET_MATERIALS_TABLE_ID", res.data);
    });
  },
  FETCH_MATERIAL_REMAINS({ commit }, params) {
    return getMaterialRemains(params).then((res) => {
      commit("SET_MATERIAL_REMAINS", res.data);
      return res;
    });
  },
  FETCH_MATERIAL_REMAINS_EXCEL({ commit }, params) {
    return getMaterialRemainsExcel(params).then((res) => {
      return res;
    });
  },
  FETCH_MATERIALS_FOR_ENTERING({ commit }, params) {
    return getMaterialsTableId(params).then((res) => {
      commit("SET_MATERIALS_FOR_ENTERING", res.data);
    });
  },
  DELETE_MATERIALS_TABLE_ID(_, id) {
    return deleteMaterialsVidId(id);
  },

  UPDATE_MATERIALS_TABLE_ID(_, data) {
    return updateMaterialsVid(data);
  },

  CREATE_WRITE_OFF_FOR_GOOD(_, data) {
    return createWriteOffForGood(data);
  },

  UPDATE_WRITE_OFF_FOR_GOOD(_, data) {
    return updateWriteOffForGood(data);
  },
  UPDATE_WRITE_OFF_FOR_INSTRUMENT(_, data) {
    return updateWriteOffForInstrument(data);
  },
  EXPORT_EXCEL_MATERIAL_TYPES(_, params) {
    return exportExcelMaterialTypes(params);
  },
  EXPORT_EXCEL_MATERIALS(_, params) {
    return exportExcelMaterial(params);
  },
};
